import classNames from "classnames";
import type { PropsWithChildren } from "react";

/** Clips overflowing text to a single ellipsized line.
 *
 * The caller supplies the width bound (`max-w-*`) it wants; this only sets the
 * clipping behavior, so the two never fight over the same CSS property.
 */
export const ClipDiv: React.FC<PropsWithChildren<{ className?: string }>> = ({
  children,
  className,
}) => (
  <div
    className={classNames(
      "overflow-x-clip text-ellipsis whitespace-nowrap",
      className
    )}
  >
    {children}
  </div>
);
